import React, { useState, useEffect } from 'react';
import EventLogDetailTable from './eventLogDetailTable/EventLogDetailTable';
import EventLogDetailSearchBar from './eventLogDetailSearchBar/EventLogDetailSearchBar';

const EventLogDetail = () => {
  const [ data, setData ] = useState([]);
  const [ warningLogIdxs, setWarningLogIdxs] = useState([]);
  const [ searchMap, setSearchMap ] = useState({
                                        dateValid: false,
                                        beginDate: new Date(),
                                        endDate: new Date(),
                                        moduleIdx: 0,
                                      })

  return(
    <section>
      <EventLogDetailSearchBar setData={setData}
                               searchMap={searchMap}
                               setSearchMap={setSearchMap}
                               warningLogIdxs={warningLogIdxs} />
      <EventLogDetailTable data={data} setData={setData} searchMap={searchMap} setWarningLogIdxs={setWarningLogIdxs} />
    </section>
  )
}

export default EventLogDetail;